import React from 'react';
import { map } from 'lodash';
import cn from 'classnames';
import { useIntl } from 'react-intl';

import { SettingsDropdown } from 'components';
import arrows from 'assets/svg/exchange-arrows.svg';
import useOddFormatSelect from './useOddFormatSelect';
import { msgMapping } from './constants';
import './oddFormatSelect.scss';

interface Props {}

const OddFormatSelect: React.FC<Props> = () => {
    const { formatMessage } = useIntl();
    const {
        currOddFormat,
        title,
        filteredOddFormats,
        onMouseDown,
    } = useOddFormatSelect();

    return (
        <SettingsDropdown title={title} glyph={arrows} width={17} height={17}>
            <div styleName="options">
                {map(filteredOddFormats, item => (
                    <div
                        key={item}
                        data-format={item}
                        styleName={cn('option', {
                            'is-selected': currOddFormat === item,
                        })}
                        onMouseDown={onMouseDown}
                    >
                        {formatMessage(msgMapping[item])}
                    </div>
                ))}
            </div>
        </SettingsDropdown>
    );
};

export default OddFormatSelect;
